import styled, { css } from 'styled-components';
import { Flex } from 'antd';
import { focusHaloBleed } from './scrollGutter';

export const UserWrapper = styled.span`
  height: 19px;
  padding: 2px 12px;
  border: 1px solid var(--clr-general-primary);
  background: rgba(var(--clr-general-primary-rgb), 0.1);
  border-radius: 60px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  font-size: 10px;
  color: var(--clr-title);
  line-height: 100%;
  white-space: nowrap;
  position: absolute;
  top: 0;
  right: 0;
`;

export const UserDetails = styled.div`
  flex: 1;
  min-width: 0;
  h3,
  p {
    margin-top: 4px;
  }
`;

export const AvatarWrapper = styled(Flex)`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: var(--clr-body-bg);
  flex-shrink: 0;
  position: relative;
  .photo-upload-wrapper {
    position: absolute;
    z-index: 1;
    width: 30px;
    height: 30px;
    border-radius: 50px;
    background: var(--clr-general-primary);
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--clr-body-bg);
    right: 0;
    bottom: -1px;
    padding: 0;
    &:not(:disabled):not(.ant-btn-disabled):hover {
      background-color: var(--clr-general-primary);
      border-color: var(--clr-body-bg);
    }
    .icon {
      font-size: 20px;
      color: var(--clr-white);
      flex-shrink: 0;
    }
  }
`;

const avatarCircle = css`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  flex-shrink: 0;
  overflow: hidden;
  background: linear-gradient(180deg, var(--clr-primary-light) 0%, var(--clr-general-primary) 100%)
    content-box;
  border-style: solid;
  border-color: rgba(var(--clr-general-primary-rgb), 0.6);
  color: var(--clr-white);
  font-weight: 600;
  line-height: 100%;
  &:has(img) {
    border: 0;
    padding: 0;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
`;

export const MenuAvatarCircle = styled.span`
  ${avatarCircle};
  width: 18px;
  height: 18px;
  border-width: 0.75px;
  padding: 1px;
  font-size: 7px;
`;

export const ProfileAvatarCircle = styled.span`
  ${avatarCircle};
  width: 80px;
  height: 80px;
  border-width: 2px;
  padding: 3px;
  font-size: 30px;
`;

export const AvatarErrorMessage = styled(Flex)`
  color: var(--clr-inline-error);
  font-size: 11px;
  line-height: 16px;
  font-style: italic;
  .icon {
    flex-shrink: 0;
    font-size: 12px;
  }
`;

export const SettingContent = styled(Flex)`
  /* Doubled to outrank the .scroll-page-gutter class these pages also carry. */
  && {
    ${focusHaloBleed}
  }
  height: 100%;
  .default-view-heading {
    position: sticky;
    top: calc(-1 * var(--spacing-gutter));
    background-color: var(--clr-body-bg);
    z-index: 1;
    padding-bottom: 10px;
  }
`;

export const ApplicationSettingsWrapper = styled(Flex)`
  border: 1px solid var(--clr-border-grey-100);
  border-radius: 5px;
  /* Matches the modal it sits in, and lifts the card off the page background on About. */
  background-color: var(--clr-container-bg);
  padding: 10px 15px;
  .settings-item {
    &:last-child {
      flex-direction: column;
      span {
        white-space: break-spaces;
      }
    }
  }
`;

export const VersionContainer = styled(Flex)`
  background-color: var(--clr-general-primary);
  border-radius: 5px;
  padding: 5px 15px;
  width: 100%;
  margin-bottom: 5px;
  p,
  span {
    color: var(--clr-white) !important;
  }
`;

export const ReleaseFeaturesList = styled.ul`
  padding-left: 20px;
  font-size: 12px;
  line-height: 20px;
  color: var(--clr-subtitle);

  li {
    position: relative;
    margin-bottom: 0;
    padding-left: 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const SectionHeadingRow = styled(Flex)`
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 4px;
  background-color: var(--clr-container-bg);
  text-transform: uppercase;

  .section-heading-rule {
    flex: none;
    width: 60px;
    height: 1px;
    background: linear-gradient(
      270deg,
      var(--clr-general-primary) 0%,
      rgba(var(--clr-general-primary-rgb), 0) 100%
    );
  }

  /* the rule fades away from the label on either side, so the trailing half runs the other way */
  .section-heading-rule:last-child {
    background: linear-gradient(
      90deg,
      var(--clr-general-primary) 0%,
      rgba(var(--clr-general-primary-rgb), 0) 100%
    );
  }
`;

export const ReleaseNotesContainer = styled(Flex)`
  max-height: 300px;
  overflow-y: auto;
  p,
  span,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  div {
    font-size: 12px;
    color: var(--clr-subtitle);
  }
  ol,
  ul {
    padding-left: 15px;
    li {
      font-size: 12px;
      color: var(--clr-subtitle);
    }
  }
  .ant-spin-dot {
    color: var(--clr-genral-primary);
  }
`;
